import recursiveFunctionStepParser from '../recursiveFunctionStepParser';
import resolveExpression from '../simpleScript/expressionParser/resolveExpression';

export default async function(
    functionObj={},
    variableObject={},
    parameterObject={},
    functionMap={},
    variableIdMap={},
    setStateFunction
){
    try{
        const {
            executionObject={}
        } = functionObj;
        const {
            intervalId={}
        } = executionObject;

        let variableCopy = variableObject;
        let resolvedQuery = await resolveExpression(
            intervalId,
            variableObject,
            parameterObject,
            functionMap,
            variableIdMap
        );
        let resolvedIntervalId = resolvedQuery.value;
        variableCopy = resolvedQuery.variableObject;

        clearInterval(resolvedIntervalId);

        return {
            hasReturnStatement : false,
            returnStatement : undefined,
            updatedVariableObject : variableCopy,
            hasError : false,
            errorPayload : undefined
        };
    }catch(e){
        console.log('/utils/functionParser/general/functionTypeParser/clearIntervalParser catch block error', e)
        return {
            updatedVariableObject : variableObject,
            hasError : true,
            errorPayload : e.stack,
            hasReturnStatement : false,
            returnStatement : undefined
        }
    }
}